
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import 'react-toastify/dist/ReactToastify.css';
import images from "../Images/logo.png"
const courseOptions = [
  "Web Development", "Graphic Designing", "Dom Excel","Forex Trading", "Digital Marketing",
  "Data Science", "Spoken English", "UI/UX Designing", "Python Programming"
];

const batchOptions = Array.from({ length: 100 }, (_, i) => i + 1);

export default function AddStudent({ studentData = null, onSuccess }) {
  const [formData, setFormData] = useState({
    studentName: '', fatherName: '', birthDate: '', gender: '', division: '',
    district: '', address: '', phone1: '', phone2: '', email: '',
    occupation: '', maritalStatus: '', courseName: '', image: null,
    batch: '', admissionFee: '', courseFee: '', certificateFarewellCharges: '',
    acCharges: '', installment: '', discount: '', total: ''
  });

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (studentData) {
      setFormData({
        studentName: studentData.studentName || '',
        fatherName: studentData.fatherName || '',
        birthDate: studentData.birthDate || '',
        gender: studentData.gender || '',
        division: studentData.division || '',
        district: studentData.district || '',
        address: studentData.address || '',
        phone1: studentData.phone1 || '',
        phone2: studentData.phone2 || '',
        email: studentData.email || '',
        occupation: studentData.occupation || '',
        maritalStatus: studentData.maritalStatus || '',
        courseName: studentData.courseName || '',
        batch: studentData.batch || '',
        image: null,
        admissionFee: studentData.admissionFee || '',
        courseFee: studentData.courseFee || '',
        certificateFarewellCharges: studentData.certificateFarewellCharges || '',
        acCharges: studentData.acCharges || '',
        installment: studentData.installment || '',
        discount: studentData.discount || '',
        total: studentData.total || ''
      });
    }
  }, [studentData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData((prev) => ({ ...prev, image: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectCourse = (course) => {
    setFormData((prev) => ({ ...prev, courseName: course }));
    setIsDropdownOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      for (let key in formData) data.append(key, formData[key]);

      let firstSuccess = false;

      try {
        if (studentData && studentData._id) {
          await axios.put(`https://expertb.codebyte.live/api/updateStudent/${studentData._id}`, data, { headers: { "Content-Type": "multipart/form-data" } });
        } else {
          await axios.post('https://expertb.codebyte.live/api/addstudent', data, { headers: { "Content-Type": "multipart/form-data" } });
        }
        firstSuccess = true;
        toast.success("Student processed successfully!");
      } catch (err) {
        console.warn("First API failed, trying fallback API", err);
      }

      if (!firstSuccess) {
        if (studentData && studentData._id) {
          await axios.put(`https://expertb.codebyte.live/api/admin/updateStudent/${studentData._id}`, data, { headers: { "Content-Type": "multipart/form-data" } });
        } else {
          await axios.post('https://expertb.codebyte.live/api/admin/addstudent', data, { headers: { "Content-Type": "multipart/form-data" } });
        }
        toast.success("Student processed successfully!");
      }

      if (onSuccess) onSuccess();

      if (!studentData) setFormData({
        studentName: '', fatherName: '', birthDate: '', gender: '', division: '',
        district: '', address: '', phone1: '', phone2: '', email: '',
        occupation: '', maritalStatus: '', courseName: '', image: null,
        batch: '', admissionFee: '', courseFee: '', certificateFarewellCharges: '',
        acCharges: '', installment: '', discount: '', total: ''
      });

    } catch (err) {
      console.error(err);
      toast.error("Failed to submit student.");
    }
  };

  // Capitalize text utility
  const capitalize = (text) => text ? text.toUpperCase() : '';

 const generatePDF = () => {
  const pdfContainer = document.createElement('div');
  pdfContainer.style.width = '210mm';
  pdfContainer.style.minHeight = '297mm';
  pdfContainer.style.padding = '20px';
  pdfContainer.style.background = '#ffffff';
  pdfContainer.style.fontFamily = "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif";
  pdfContainer.style.position = 'absolute';
  pdfContainer.style.left = '-9999px';
  pdfContainer.style.boxSizing = 'border-box';

  const studentImgSrc = formData.image 
    ? URL.createObjectURL(formData.image) 
    : studentData?.image 
      ? `https://expertb.codebyte.live/uploads/${studentData.image}` 
      : '';

  const logoSrc = images

  pdfContainer.innerHTML = `
    <div style="background:#b91c1c; padding:15px; color:white; text-align:center; border-radius:8px 8px 0 0; position:relative;">
      <img src="${logoSrc}" style="position:absolute; top:10px; left:10px; width:80px; height:auto;" />
      <h1 style="margin:0; font-size:24px;">ADMISSION FORM</h1>
      <div style="position:absolute; top:15px; right:15px; width:100px; height:100px; border-radius:50%; overflow:hidden; border:2px solid white;">
        <img src="${studentImgSrc}" crossorigin="anonymous" style="width:100%; height:100%; object-fit:cover; border-radius:50%;" />
      </div>
    </div>
    <div style="padding:20px; display:flex; flex-direction:column; gap:15px;">
      <div>
        <h3 style="color:#b91c1c; border-bottom:1px solid #b91c1c; padding-bottom:5px; margin-bottom:10px;">PERSONAL INFORMATION</h3>
        <p><strong>STUDENT NAME:</strong> ${formData.studentName.toUpperCase()}</p>
        <p><strong>FATHER NAME:</strong> ${formData.fatherName.toUpperCase()}</p>
        <p><strong>BIRTH DATE:</strong> ${formData.birthDate.toUpperCase()}</p>
        <p><strong>GENDER:</strong> ${formData.gender.toUpperCase()}</p>
      </div>
      <div>
        <h3 style="color:#b91c1c; border-bottom:1px solid #b91c1c; padding-bottom:5px; margin-bottom:10px;">PRESENT ADDRESS</h3>
        <p><strong>DIVISION:</strong> ${formData.division.toUpperCase()}</p>
        <p><strong>DISTRICT:</strong> ${formData.district.toUpperCase()}</p>
        <p><strong>ADDRESS:</strong> ${formData.address.toUpperCase()}</p>
        <p><strong>PHONE:</strong> ${formData.phone1.toUpperCase()}  ${formData.phone2.toUpperCase()}</p>
        <p><strong>EMAIL:</strong> ${formData.email.toUpperCase()}</p>
      </div>
      <div>
        <h3 style="color:#b91c1c; border-bottom:1px solid #b91c1c; padding-bottom:5px; margin-bottom:10px;">OCCUPATION</h3>
        <p><strong>OCCUPATION:</strong> ${formData.occupation.toUpperCase()}</p>
        <p><strong>MARITAL STATUS:</strong> ${formData.maritalStatus.toUpperCase()}</p>
      </div>
      <div>
        <h3 style="color:#b91c1c; border-bottom:1px solid #b91c1c; padding-bottom:5px; margin-bottom:10px;">COURSE & SERVICES INFO</h3>
        <p><strong>COURSE NAME:</strong> ${formData.courseName.toUpperCase()}</p>
        <p><strong>BATCH:</strong> ${formData.batch.toUpperCase()}</p>
        <p><strong>ADMISSION FEE:</strong> ${formData.admissionFee.toUpperCase()}</p>
        <p><strong>COURSE FEE:</strong> ${formData.courseFee.toUpperCase()}</p>
        <p><strong>CERTIFICATE/FAREWELL CHARGES:</strong> ${formData.certificateFarewellCharges.toUpperCase()}</p>
        <p><strong>A/C CHARGES:</strong> ${formData.acCharges.toUpperCase()}</p>
        <p><strong>INSTALLMENT:</strong> ${formData.installment.toUpperCase()}</p>
        <p><strong>DISCOUNT:</strong> ${formData.discount.toUpperCase()}</p>
        <p style="margin-top:10px; font-weight:bold; font-size:16px; color:#b91c1c; border-top:1px dashed #b91c1c; padding-top:5px;">TOTAL: ${formData.total.toUpperCase()}</p>
      </div>
    </div>
    <div style="display:flex; justify-content:space-between; margin-top:30px;">
      <span>STUDENT SIGNATURE: ____________________</span>
      <span>DIRECTOR SIGNATURE: ____________________</span>
    </div>
    <div style="background:#b91c1c; height:15px; border-radius:0 0 8px 8px; margin-top:20px;"></div>
  `;

  document.body.appendChild(pdfContainer);

  html2canvas(pdfContainer, { scale: 2, useCORS: true }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${formData.studentName || 'STUDENT'}_ADMISSION_FORM.pdf`);
    document.body.removeChild(pdfContainer);
  });
};

  return (
    <div className="relative min-h-screen bg-white text-red-600 p-4 sm:p-6">
      <div className="max-w-6xl mx-auto shadow-xl rounded-xl p-4 sm:p-6 bg-white relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between mb-6 md:mb-8 gap-6">
          <h1 className="text-2xl md:text-3xl font-bold">{studentData ? 'Update Student' : 'Admission Form'}</h1>
          <div className="flex flex-col items-center border-2 border-dashed border-red-300 rounded-lg p-4 w-full sm:w-60 bg-white z-10">
            <div className="w-24 h-24 rounded-full bg-gray-100 overflow-hidden flex items-center justify-center mb-2">
              {formData.image ? (
                <img src={URL.createObjectURL(formData.image)} alt="Preview" className="object-cover w-full h-full" />
              ) : studentData?.image ? (
                <img src={`https://expertb.codebyte.live/uploads/${studentData.image}`} alt="Profile" className="object-cover w-full h-full" />
              ) : (
                <span className="text-xs text-gray-500">No Image</span>
              )}
            </div>
            <label className="text-sm font-medium mb-1">Choose Profile Pic</label>
            <input type="file" name="image" accept="image/*" onChange={handleChange} className="text-xs" />
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Personal Info Inputs */}
          <input name="studentName" value={formData.studentName} placeholder="Student Name" onChange={handleChange} className="input" />
          <input name="fatherName" value={formData.fatherName} placeholder="Father Name" onChange={handleChange} className="input" />
          <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} className="input" />
          <div className="flex items-center gap-4 border px-4 py-2 rounded-md">
            <label>Gender:</label>
            <label><input type="radio" name="gender" value="Male" onChange={handleChange} checked={formData.gender === 'Male'} /> Male</label>
            <label><input type="radio" name="gender" value="Female" onChange={handleChange} checked={formData.gender === 'Female'} /> Female</label>
          </div>
          <input name="division" value={formData.division} placeholder="Division" onChange={handleChange} className="input" />
          <input name="district" value={formData.district} placeholder="District" onChange={handleChange} className="input" />
          <input name="address" value={formData.address} placeholder="Address" onChange={handleChange} className="input" />
          <input name="phone1" value={formData.phone1} placeholder="Phone Number" onChange={handleChange} className="input" />
          <input name="phone2" value={formData.phone2} placeholder="Alternate Number" onChange={handleChange} className="input" />
          <input name="email" type="email" value={formData.email} placeholder="Email Address" onChange={handleChange} className="input" />
          <input name="occupation" value={formData.occupation} placeholder="Occupation" onChange={handleChange} className="input" />
          <div className="flex items-center gap-4 border px-4 py-2 rounded-md">
            <label>Marital Status:</label>
            <label><input type="radio" name="maritalStatus" value="Single" onChange={handleChange} checked={formData.maritalStatus === 'Single'} /> Single</label>
            <label><input type="radio" name="maritalStatus" value="Married" onChange={handleChange} checked={formData.maritalStatus === 'Married'} /> Married</label>
          </div>

          {/* Course */}
          <div className="relative col-span-1 md:col-span-2">
            <button type="button" onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="input text-left">
              {formData.courseName || 'Select Course'}
            </button>
            {isDropdownOpen && (
              <ul className="absolute z-30 w-full mt-1 bg-white border rounded-md max-h-64 overflow-y-auto shadow-lg">
                {courseOptions.map((course) => (
                  <li key={course} onClick={() => handleSelectCourse(course)} className="px-4 py-2 cursor-pointer hover:bg-red-100">{course}</li>
                ))}
              </ul>
            )}
          </div>

          <select name="batch" value={formData.batch} onChange={handleChange} className="input col-span-1 md:col-span-2">
            <option value="">Select Batch</option>
            {batchOptions.map((b) => <option key={b} value={b}>{b}</option>)}
          </select>

          {/* Admission Details */}
          <h2 className="col-span-2 text-lg font-bold mt-4">Admission Details</h2>
          <input name="admissionFee" value={formData.admissionFee} placeholder="Admission Fee" onChange={handleChange} className="input" />
          <input name="courseFee" value={formData.courseFee} placeholder="Course Fee" onChange={handleChange} className="input" />
          <input name="certificateFarewellCharges" value={formData.certificateFarewellCharges} placeholder="Certificate / Farewell Charges" onChange={handleChange} className="input" />
          <input name="acCharges" value={formData.acCharges} placeholder="A/C Charges" onChange={handleChange} className="input" />
          <input name="installment" value={formData.installment} placeholder="Installment" onChange={handleChange} className="input" />
          <input name="discount" value={formData.discount} placeholder="Discount" onChange={handleChange} className="input" />
          <input name="total" value={formData.total} placeholder="Total" onChange={handleChange} className="input" />

          <button type="submit" className="bg-red-600 text-white py-2 rounded-md col-span-2 hover:bg-red-700">{studentData ? 'Update' : 'Submit'}</button>
          <button type="button" onClick={generatePDF} className="bg-gray-800 text-white py-2 rounded-md col-span-2 hover:bg-gray-900">Download PDF</button>
        </form>
      </div>

      <ToastContainer position="top-center" />

      <style>{`
        .input { padding:0.5rem 1rem; border:1px solid #ccc; border-radius:0.375rem; outline:none; width:100%; color:#b91c1c; }
        .input:focus { border-color:#b91c1c; box-shadow:0 0 0 1px #b91c1c; }
        ::placeholder { color:#b91c1c; }
      `}</style>
    </div>
  );
}
